import { Component, forwardRef, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { PhonNumberValidators } from '@zero/shared/util-form-validators';

const VALIDATOR = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => PhoneInputComponent),
  multi: true,
};
const PHONE_CONTROL_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PhoneInputComponent),
  multi: true,
};

@Component({
  selector: 'web-components-phone-input',
  templateUrl: './phone-input.component.html',
  providers: [VALIDATOR, PHONE_CONTROL_ACCESSOR],
  imports: [FormsModule],
})
export class PhoneInputComponent implements OnInit, Validator, ControlValueAccessor {
  public phoneNrInput: string;
  public isEmpty: boolean;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onValueChange: (val: any) => void;
  public onInputTouched: () => void;

  ngOnInit(): void {
    this.phoneNrInput = '+491';
    this.isEmpty = false;
  }

  public validate(control: AbstractControl): ValidationErrors | null {
    return PhonNumberValidators.phoneNumberValidator()(control);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public writeValue(obj: any): void {
    if (obj) {
      this.phoneNrInput = obj;
      this.isEmpty = false;
    } else {
      this.phoneNrInput = '+491';
      this.isEmpty = false;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public registerOnChange(fn: any): void {
    this.onValueChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public registerOnTouched(fn: any): void {
    this.onInputTouched = fn;
  }

  public updatePhoneNumber(): void {
    if (this.phoneNrInput) {
      if (this.phoneNrInput.startsWith('00')) {
        this.phoneNrInput = `+${this.phoneNrInput.substring(2)}`;
      } else if (RegExp(/^0[1-9]+/).exec(this.phoneNrInput)) {
        this.phoneNrInput = `+49${this.phoneNrInput.substring(1)}`;
      }
    }

    if (this.phoneNrInput) {
      this.isEmpty = false;
    } else {
      this.isEmpty = true;
    }

    this.onValueChange(this.phoneNrInput ? this.phoneNrInput.replace(/^\+49\D*0/, '+49').replace(/[^+0-9]/g, '') : undefined);
    this.onInputTouched();
  }
}
